interface Config {
    enableVaccineStatus: boolean;
    splitFamilyGivenName: boolean;
    enableHKID: boolean;
    enableCovidCertificates: boolean;
    clinicManagedAccounts: boolean;
    region: string;
}

function stringToBoolean(str: string) {
    const truthyValues = ['true', 'yes', '1'];
    return truthyValues.includes(str.toLowerCase());
}

const config: Config = {
    enableVaccineStatus: stringToBoolean(window._env_['ENABLE_VACCINE_STATUS']),
    splitFamilyGivenName: stringToBoolean(window._env_['SPLIT_FAMILY_GIVEN_NAME']),
    enableHKID: stringToBoolean(window._env_['ENABLE_HKID']),
    enableCovidCertificates: stringToBoolean(window._env_['ENABLE_COVID_CERTIFICATES']),
    clinicManagedAccounts: stringToBoolean(window._env_['CLINIC_MANAGED_ACCOUNTS']),
    region: window._env_['REGION'],
};

export default config;
